// Item 216 batch 4 — group-mapping dry-run tester client. Backs the
// SetupWizard's SSO step "Test group mapping" form: feeds
// operator-typed group / app-role / email values through the same
// classifier RequireAuth uses so "this user would have role X" can be
// checked before a live SSO login. Read-only — nothing is persisted,
// the group lists it reads stay env/file-sourced.

import { parseErrorResponse } from './problem';

export interface SAMLGroupMappingMatch {
  identifier: string;
  source: 'group' | 'app_role' | 'email';
  role?: string;
}

export interface SAMLGroupMappingTestResult {
  matches: SAMLGroupMappingMatch[];
  roles: string[];
}

export async function testSAMLGroupMapping(
  groups: string[],
  appRoles: string[],
  email: string,
): Promise<SAMLGroupMappingTestResult> {
  const res = await fetch('/api/admin/saml/group-mapping/test', {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ groups, app_roles: appRoles, email }),
  });
  if (!res.ok) throw await parseErrorResponse(res);
  return res.json();
}
